// @symbo.ls/collab-features/meet — room + participant + transcript
// helpers. Token minting + AI analysis stay on edge functions; these
// are thin read/write wrappers for room catalog + transcript retrieval.

import { getClient, PROJECT_GOVERNANCE } from '../../../governanceBridge.js'

export const MEET_CONFIG = Object.freeze({
  projectName: PROJECT_GOVERNANCE,
  tables: {
    rooms: 'meet_rooms',
    members: 'meet_room_members',
    participants: 'meet_participants',
    transcripts: 'meet_transcripts',
    analyses: 'meet_transcript_analyses',
    waitingRoom: 'meet_waiting_room',
    meetings: 'meetings'
  }
})

const _sb = () => getClient(MEET_CONFIG.projectName)
export const meetAvailable = () => !!_sb()

export const listRooms = async ({ includeEnded = false } = {}) => {
  const sb = _sb()
  if (!sb) return { data: [], error: null }
  let q = sb.from(MEET_CONFIG.tables.rooms).select('*').order('created_at', { ascending: false })
  if (!includeEnded) q = q.is('ended_at', null)
  return q
}

export const getRoom = async (id) => {
  const sb = _sb()
  if (!sb) return { data: null, error: null }
  return sb.from(MEET_CONFIG.tables.rooms).select('*').eq('id', id).maybeSingle()
}

export const createRoom = async (row) => {
  const sb = _sb()
  if (!sb) return { data: null, error: new Error('governance unavailable') }
  return sb.from(MEET_CONFIG.tables.rooms).insert(row).select('*').single()
}

export const listTranscripts = async (roomId) => {
  const sb = _sb()
  if (!sb) return { data: [], error: null }
  return sb
    .from(MEET_CONFIG.tables.transcripts)
    .select('*')
    .eq('room_id', roomId)
    .order('started_at', { ascending: true })
}

export const getLatestAnalysis = async (roomId) => {
  const sb = _sb()
  if (!sb) return { data: null, error: null }
  return sb
    .from(MEET_CONFIG.tables.analyses)
    .select('*')
    .eq('room_id', roomId)
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle()
}
